import { clsx as o } from "clsx";
import { isFunction as p } from "@sniptt/guards";
var x = (t, r) => (i) => o(t, p(r) ? r(i) : r);
export {
  x as t
};
